module.exports = __webpack_public_path__ + "static/media/career-video-bg.86caa234.png";